var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-left-chart-2"},[_c('div',{staticClass:"header-name"},[_vm._v("任务维修平均用时")]),_vm._m(0),_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details-value"},[_c('span',[_vm._v("55.1")]),_vm._v("小时")])
}]

export { render, staticRenderFns }